import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Prevent multiple client instances during HMR in dev mode
if (typeof window !== 'undefined' && !window.__supabaseClient) {
    window.__supabaseClient = createClient(supabaseUrl, supabaseAnonKey, {
        auth: {
            autoRefreshToken: true,
            persistSession: true,
            detectSessionInUrl: true,
            storage: typeof window !== 'undefined' ? window.localStorage : undefined,
            storageKey: 'kodeo-auth-token',
            flowType: 'pkce'
        }
    });
}

export const supabase = typeof window !== 'undefined'
    ? window.__supabaseClient
    : createClient(supabaseUrl, supabaseAnonKey, {
        auth: {
            autoRefreshToken: true,
            persistSession: true,
            detectSessionInUrl: true,
            storageKey: 'kodeo-auth-token',
            flowType: 'pkce'
        }
    })